import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';

enum StepStage {
    NONE = 0,
    STEP1 = 1,
    STEP2 = 2,
    STEP3 = 3,
    STEP4 = 4
}
type Emits = {
    (e: 'progress'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'instructions-setup',
  emits: ["progress"],
  setup(__props, { expose, emit }: { emit: ({
    (e: 'progress'): void
}), expose: any, slots: any, attrs: any }) {
  expose();


const stage = ref(StepStage.NONE);
const updateStage = (click_val: number) => {
    stage.value = (click_val === stage.value) ? 0 : click_val
    return stage
}


const __returned__ = { StepStage, emit, stage, updateStage, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})